export default __webpack_public_path__ + "static/media/giftGif.4ffb7edf.gif";